import React from 'react';
import PropTypes from 'prop-types';
import EventCard from '../EventCard';

const EventsList = ({ events, onEveryEventClick, isEveryEventLink }) => (
  <div>
    {!!events &&
      events.map((event) => (
        <EventCard
          key={`event-${event.id || event.name}`}
          event={event}
          onClick={onEveryEventClick}
          isLink={isEveryEventLink}
        />
      ))}
  </div>
);

EventsList.propTypes = {
  events: PropTypes.arrayOf(Array).isRequired,
  onEveryEventClick: PropTypes.func,
  isEveryEventLink: PropTypes.bool,
};

EventsList.defaultProps = {
  onEveryEventClick: () => '',
  isEveryEventLink: false,
};

export default EventsList;
